(() => {
  const initialized = new WeakSet();

  function initGallery(gallery) {
    if (initialized.has(gallery)) return;
    initialized.add(gallery);

    const panels = Array.from(gallery.querySelectorAll('[data-arden-if-panel]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-arden-if-thumb]'));
    if (panels.length < 2 || thumbs.length < 2) return;

    let activeIndex = 0;
    let touchStartX = null;

    const select = (index, focusThumb = false) => {
      activeIndex = (index + panels.length) % panels.length;
      panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== activeIndex;
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === activeIndex;
        thumb.setAttribute('aria-selected', selected ? 'true' : 'false');
        thumb.tabIndex = selected ? 0 : -1;
        if (selected) {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          if (focusThumb) thumb.focus();
        }
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => select(Number(thumb.dataset.index)));
      thumb.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        select(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
    });

    const stage = gallery.querySelector('.arden-if-gallery__stage');
    stage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 42) return;
      select(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    select(0);
  }

  function initMain(main) {
    if (initialized.has(main)) return;
    initialized.add(main);

    main.querySelectorAll('[data-arden-if-gallery]').forEach(initGallery);

    const sticky = main.querySelector('[data-arden-if-sticky]');
    const mainAdd = main.querySelector('[data-arden-if-add]');
    const stickyAdd = main.querySelector('[data-arden-if-sticky-add]');
    if (!sticky || !mainAdd || !stickyAdd || main.dataset.stickyEnabled !== 'true') return;

    stickyAdd.addEventListener('click', () => {
      if (!mainAdd.disabled) mainAdd.click();
    });

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.hidden = !hasPassedButton;
    }, { threshold: 0 });
    observer.observe(mainAdd);
  }

  function init(scope = document) {
    if (scope.matches?.('[data-arden-if-main]')) initMain(scope);
    scope.querySelectorAll?.('[data-arden-if-main]').forEach(initMain);
    scope.querySelectorAll?.('[data-arden-if-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
